export default __webpack_public_path__ + "static/media/214.89fdbc6c.png";